/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

 import React from "react"
 import PropTypes from "prop-types"
 import { Helmet } from "react-helmet"
 import { ACTION_TYPES, getPriceStr } from "./utils"
 import { useLocation } from "@reach/router"

 const SeoResults = ({ description, lang, meta, title, searchParams, location, url: metaurl }) => {
 
   const {areas, bedrooms, pType, type, price } = searchParams;
  
   var { pathname } = useLocation()
 
   const url = metaurl
  ? metaurl
  :null;
   const actionStr = ACTION_TYPES[pType];
   const priceStr = getPriceStr(price)
  //  const bedRooms = searchParams.bedrooms
 
   let propertyType = ""
 
   if(type === "") {
     propertyType = "property"
   } else {
     propertyType = type
   }
 
   const capitalize = (s) => {
     if (typeof s !== 'string') return ''
     return s.charAt(0).toUpperCase() + s.slice(1)
   }
 
     //
     let titlePropertyType = ""
 
     if(type === "") {
         titlePropertyType = "Property"
     } else if(type === "apartment") {
         titlePropertyType = "Apartments"
     } else if(type === "house") {
         titlePropertyType = "Houses"
     } else if(type === "maisonette") {
         titlePropertyType = "Maisonette"
     } else if(type === "property") {
         titlePropertyType = "Property"
     } else if(type === "bungalow") {
         titlePropertyType = "Bungalow"
     } else if(type === "land") {
         titlePropertyType = "Land"
     } else if(type === "commercial") {
         titlePropertyType = "Commercial"
     } else {
         titlePropertyType = type
     }
 
     let bedroomType = ""
 
     if ( bedrooms ) {
       bedroomType = bedrooms + ' + Bedroom '
     }
 
     let descTitle = title ? title : bedroomType + capitalize(titlePropertyType) + actionStr + capitalize(areas) + priceStr
     //
     
  const generateMetaDescription = ({ areas, type, bedrooms, price }) => {

  if (!actionStr || !areas) return "";

  // Helper for price text
  const priceText = price?.min && price?.max
    ? `between £${price.min} and £${price.max}`
    : price?.min
      ? `over £${price.min}`
      : price?.max
        ? `under £${price.max}`
        : "";

  // Case: type + bedrooms + price
  if (type && bedrooms && priceText) {
    return `Find ${bedrooms}+ bedroom ${type}s${actionStr}${areas} ${priceText} with Bentley Hurst, our experts help you find the perfect ${type} in ${areas}.`;
  }

  // Case: type + bedrooms
  if (type && bedrooms) {
    return `Check ${bedrooms}+ bedroom ${type}s${actionStr}${areas}. Contact Bentley Hurst, leading estate and letting agents in ${areas}.`;
  }

  // Case: bedrooms + price
  if (bedrooms && priceText) {
    return `Find ${bedrooms}+ bedroom properties${actionStr}${areas} ${priceText} with Bentley Hurst. Our property experts are here to help with all your property needs.`;
  }

  // Case: type + price
  if (type && priceText) {
    return `Here is the latest collection of ${type}s${actionStr}${areas} ${priceText} with Bentley Hurst, the leading estate and letting agents in ${areas}.`;
  }

  // Case: only type
  if (type) {
    return `Looking for ${type}s${actionStr}${areas}? Bentley Hurst property experts are here to help with your property needs.`;
  }

  // Case: only bedrooms
  if (bedrooms) {
    return `Check ${bedrooms}+ bedroom properties${actionStr}${areas}. Book an appointment with one of our specialists today to find the perfect property${actionStr.replace("in", "")} anywhere in ${areas}.`;
  }

  // Case: only price
  if (priceText) {
    return `Discover properties${actionStr}${areas} ${priceText}? Try Bentley Hurst. Book an appointment with one of our specialists today to find the perfect property${actionStr}${areas}.`;
  }
  
  if(pathname=="/property/for-sale/in-hale/") {
    return "Find the best residential properties for sale in Hale with Bentley Hurst. Contact our local property specialists for help finding your next home in Hale.";
  }


  // Default fallback
  return `Find the best residential properties${actionStr}${areas}. Contact our residential property specialists and get help to find property${actionStr}${areas}.`;
}
 
   description = description ? description : generateMetaDescription({ areas, type, bedrooms, price });

  var curentUrl = '';

  if (pathname == "/property/to-rent/" || pathname == "/property/to-rent" )
    pathname = "/property/to-rent/in-manchester/"
  if (pathname == "/property/for-sale/" || pathname == "/property/for-sale" )
    pathname = "/property/for-sale/in-manchester/"

  curentUrl = process.env.GATSBY_SITE_URL+pathname;

  // set no index for result pagination
  let hasPagination = false;
  if (pathname !== undefined && pathname) {
    let pageStr = pathname.split('page-');
    hasPagination = pageStr[1] || false;
    if (pageStr[0] !== undefined) {
     curentUrl = process.env.GATSBY_SITE_URL + pageStr[0];
    }
  }

  if (!curentUrl.endsWith('/'))
        curentUrl = curentUrl + '/';

  /* code for robots tag function */
 
  //  Define property types and areas you want to noindex
const blockedPropertyTypes = ["maisonette", "villa", "bungalow","penthouse"];
const blockedSpainAreas =  [
  "algorfa",
  "almoradi",
  "banos-y-mendigo",
  "benijofar",
  "bigastro",
  "cartagena",
  "ciudad-quesada",
  "cox",
  "daya-nueva",
  "dolores",
  "formentera-del-segura",
  "fortuna",
  "gran-alacant",
  "guardamar-del-segura",
  "la-marina",
  "la-romana",
  "los-alcazares",
  "los-montesinos",
  "los-urrutias",
  "orihuela",
  "orihuela-costa",
  "pilar-de-la-horadada",
  "penaguila",
  "pinoso",
  "rafal",
  "rojales",
  "roldan",
  "san-fulgencio",
  "san-javier",
  "san-miguel-de-salinas",
  "san-pedro-del-pinatar",
  "santa-pola",
  "santiago-de-la-ribera",
  "sucina",
  "torre-pacheco",
  "torrevieja",
  "vera"
];
const blockedDubaiAreas = [
  "condor",
  "dubai-hills",
  "dubai-marina",
  "jumeirah",
  "jumeirah-golf-estates",
  "lakes-tower",
  "palm-jumeirah"
];


// Function to check if current path should be noindexed
const robotsUrl = (curPath) => {
  let robotsTxt = "";
  if (!pathname.endsWith('/')){
    curPath = pathname + '/';
  }
  const pathLower = curPath.toLowerCase();

    // Check if path contains any blocked area or property type
  const matchesSpainArea = blockedSpainAreas.some((area) =>
    pathLower.includes(area)
  );
  const matchesDubaiArea = blockedDubaiAreas.some((area) =>
    pathLower.includes(area)
  );
  const matchesPropertyType = blockedPropertyTypes.some((type) =>
    pathLower.includes(`type-${type}`)
  );

  const shouldNoIndex = matchesSpainArea || matchesDubaiArea || matchesPropertyType;
  if(shouldNoIndex){
          robotsTxt =  {
              name : `robots`,
              content: "noindex, follow",
            };
        }

  return robotsTxt;
};
 
/* code for robots tag function */
 
   let metaItems = [
     {
       name: `description`,
       content: description,
     },
     robotsUrl(pathname) , 
     {
       property: `og:title`,
       content: descTitle,
     },
     {
       property: `og:description`,
       content: description,
     },
     {
       property: `og:type`,
       content: `website`,
     },
      {
        name: `og:url`,
        content: curentUrl,
      },
     {
       name: `twitter:card`,
       content: `summary`,
     },
     {
       name: `twitter:creator`,
       content: `Bentley Hurst`,
     },
     {
       name: `twitter:title`,
       content: descTitle,
     },
     {
       name: `twitter:description`,
       content: description,
     },
     {
       property: "og:url",
       content:url,
     },
     {
       property: `og:image`,
       content: `${process.env.GATSBY_SITE_URL}/images/mail-logo.png`,
     },
   ].concat(meta);
 
 
   if ( hasPagination ) {
     // metaItems.push({
     //   name: `robots`,
     //   content: `noindex`,
     // })
   }
 
   return (
     <Helmet
       htmlAttributes={{
         lang,
       }}
       title={descTitle}
      link={[
          {
              href: curentUrl,
              rel: "canonical"
          }
      ]}
       titleTemplate={`%s | Bentley Hurst`}
       meta={metaItems}
     />
   )
 }
 
 SeoResults.defaultProps = {
   lang: `en`,
   meta: [],
   description: ``,
   title: ``,
   searchParams: [],
 }
 
 SeoResults.propTypes = {
   description: PropTypes.string,
   lang: PropTypes.string,
   meta: PropTypes.arrayOf(PropTypes.object),
   title: PropTypes.string.isRequired,
   searchParams: PropTypes.any,
 }
 
 export default SeoResults
 
